import { selectAllTextInBlock } from '../helpers/selection';
export function selectTextInBlock(state, dispatch) {
  let selection = state.selection;
  let anchor = selection.$anchor;
  let parent = anchor.parent;
  // anchor.pos - anchor.parentOffset is the start of the node, -1 is its position
  let parentPosition = anchor.pos - anchor.parentOffset - 1;
  selectAllTextInBlock(state, dispatch, parent, parentPosition);
  return true;
}